import {initAnalytics} from './analytics';
import {initCookiebot} from './cookiebot';

export function init() {
  initAnalytics();
  initCookiebot();
}
